/* 
Scaffolded code: this code was scaffolded by the code generator, feel free to change it
Template: ViewModel.cst
 */
import { Injectable } from '@angular/core';
import { Observable, of } from 'rxjs';
import { map } from 'rxjs/operators';
import { emptyAddress } from 'src/app/shared/components/address-form/address-form.component';
import { FboEntityFetchService } from 'src/store/generated/client-sync.generated';
import { FboProps, FboViewModelBase } from 'src/store/generated/fbo-record.generated';
import { undefinedOrSwitchMap } from 'src/util/rxjs/operators';
import { LocationViewModel, LocationViewModelService } from './location-view-model';

export class FboViewModel extends FboViewModelBase {
  get address() {
    return this.location != null ? this.location.address : emptyAddress;
  }
  constructor(props: FboProps, public readonly location: LocationViewModel | undefined) {
    super(props);
  }
}

@Injectable({ providedIn: 'root' })
export class FboViewModelService {
  constructor(
    private readonly _fboEntityFetchService: FboEntityFetchService,
    private readonly _locationViewModel: LocationViewModelService,
  ) {}

  public getById(id: string): Observable<FboViewModel | undefined> {
    return this._fboEntityFetchService.getById(id).pipe(
      undefinedOrSwitchMap((fbo) => {
        const location$ =
          fbo.locationId != null ? this._locationViewModel.getById(fbo.locationId) : of(undefined);

        return location$.pipe(map((location) => new FboViewModel(fbo, location)));
      }),
    );
  }
}
